<template>
  <!-- use v-if because we didn't have notification at start of application-->
  <v-snackbar
    v-if="notification"
    v-model="snackbar"
    :color="notification.type"
    :timeout="3000"
    :top="true"
  >
    {{ notification.text }}
    <v-btn dark flat @click="snackbar = false">Закрыть</v-btn>
  </v-snackbar>
</template>

<script>
  export default {
    data() {
      return {
        snackbar: false
      }
    },
    computed: {
      notification() {
        //This is work around i can't manipulate this.snackbar in notification think about it
        if (this.$store.getters.notification) {
          this.snackbar = true
        }
        return this.$store.getters.notification
      }
    }
  }
</script>
